import React, {useState,useEffect} from "react"
import {Helmet} from "react-helmet";

// import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import axios from "axios"
import HoneyNav from "./components/HoneyNav"
import HoneySubNav from "./components/HoneySubNav"
// import Form from "./components/Form"
import StepOne from "./components/StepOne"
import StepTwo from "./components/StepTwo"
import StepThree from "./components/StepThree"
import StepFour from "./components/StepFour"
import Map from "./components/Map"
import MapMultiple from "./components/MapMultiple"
import Truck from './images/bbtruck.png'
import Togo from './images/to-go.png'
import Bottle from './images/bottle.png'
import Jar from './images/jar.png'
import Loader from './images/loading-loading-forever.gif'
import './App.scss';


function App() {

  // State
  const [packData, setPackData] = useState()
  const [hiveData, setHiveData] = useState()
  const [harvestData, setHarvestData] = useState()
  const [packingData, setPackingData] = useState()
  const [hiveReady, setHiveReady] =useState()
  const [harvestReady, setHarvestReady] = useState(false)
  const [packingReady, setPackingReady] = useState(false)
  const [dataReady, setDataReady] = useState(false)
  const [formError, setFormError] = useState(false)
  const [hiveLength, setHiveLength] = useState()
  const [showLoader, setShowLoader] = useState(false)
  // set state to show form screen or app
  const [showPage, setShowPage] =useState(0)
  // set state to show if multiple locations in data
  const [multipleLoc, setMultipleLoc] = useState(false)

  const [modalIsOpen, setIsOpen] = React.useState(false);

  useEffect(() => {
   // fresh start on load
   setShowLoader(false)
   setPackData()
   setHiveData()
   setHarvestData()
   setPackingData()
   setHiveReady(false)
   setHarvestReady(false)
   setPackingReady(false)
   setDataReady(false)
   setMultipleLoc(false)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      if(hiveData && multipleLoc) {
        if(hiveData.hiveLat.length === hiveLength) {
          nextPage()
        }
      } 
    },2000)
  }, [hiveData])


  const customStyles = {  
      content: {
          maxWidth: '600px',
          margin: '80px auto 0'
      //   top: '50%',
      //   left: '50%',
      //   right: 'auto',
      //   bottom: 'auto',
      //   marginRight: '-50%',
      //   transform: 'translate(-50%, -50%)',
      },
  };
  function openModal() {
      setIsOpen(true);
    }

  
  function closeModal() {
      setIsOpen(false);
  }



  const handleSubmit  = (e) => {
    e.preventDefault(); 
    setShowLoader(true)
    const batch = e.target[0].value;

    // api request
    axios.get(`https://www.busybeehoney.com//wp-json/wp/v2/packs?slug=${batch}`) 
      .then(res => {
        setPackData(res.data)
        if(res.data.length === 0) {
          setFormError(true)
          setShowLoader(false)
        } else {
          dataPrep(res.data)
          setDataReady(true)
        }
      })
      .catch(err => console.log(err))
  }

  const dataPrep = (data) => {
    const locationData = data[0].acf
    // check if multiple or single
    const harvestCounties = locationData.harvest_counties.split(',')
    const hiveCounties = locationData.hive_counties.split(',')
    setHiveLength(hiveCounties.length)
   
    if((harvestCounties.length > 1) || (hiveCounties.length > 1)) {

      /*
        multiple locations
      */
      setMultipleLoc(true)
      // match up counties and states
      const harvestStates = locationData.harvest_states.split(',')
      const hiveStates = locationData.hive_states.split(',')
      const harvestLocations = harvestCounties.map((location, i) => (`${location} County, ${harvestStates[i]}`))
      const hiveLocations = hiveCounties.map((location, i) => (`${location} County, ${hiveStates[i]}`))
      const packingLocation = `${locationData.packing_city}, ${locationData.packing_state}`
      let baseGeoCodeURL = "https://maps.googleapis.com/maps/api/geocode/json?key="
      let appkey = "AIzaSyDB9blrZbn1diWSfUegk7bw5SpitJ-C4vM"
      let harvestCoords = []
      let harvestLat = []
      let harvestLong = []
      let hiveCoords = []
      let hiveLat = []
      let hiveLong = []
  
    

      
      hiveLocations.map((loc, i, hiveLocations) => (
        // locArray.push(axios.get(baseGeoCodeURL + appkey + "&address=" + loc))
        // console.log(locArray)
        axios.get(baseGeoCodeURL + appkey + "&address=" + loc) 
        .then(res => {
          if(i + 1 === hiveLocations.length) {
            hiveCoords.push({
              lat: res.data.results[0].geometry.location.lat,
              long: res.data.results[0].geometry.location.lng
            })
            hiveLat.push(res.data.results[0].geometry.location.lat)
            hiveLong.push(res.data.results[0].geometry.location.lng)
        
            setHiveData({
              hiveCoords: hiveCoords,
              hiveLat: hiveLat,
              hiveLong: hiveLong,
            })   
          } else {
            hiveCoords.push({
              lat: res.data.results[0].geometry.location.lat,
              long: res.data.results[0].geometry.location.lng
            })
            hiveLat.push(res.data.results[0].geometry.location.lat)
            hiveLong.push(res.data.results[0].geometry.location.lng)
          }
        })
        .catch(err => console.log(err))
      )) 


      harvestLocations.map((loc, i, harvestLocations) => (
        axios.get(baseGeoCodeURL + appkey + "&address=" + loc) 
        .then(res => {
          if(i + 1 === harvestLocations.length) {
            harvestCoords.push({
              lat: res.data.results[0].geometry.location.lat,
              long: res.data.results[0].geometry.location.lng
            })
            harvestLat.push(res.data.results[0].geometry.location.lat)
            harvestLong.push(res.data.results[0].geometry.location.lng)
            setHarvestData({
              harvestCoords: harvestCoords,
              harvestLat: harvestLat,
              harvestLong: harvestLong, 
            })
            setHarvestReady(true)
          } else {
            harvestCoords.push({
              lat: res.data.results[0].geometry.location.lat,
              long: res.data.results[0].geometry.location.lng
            })
            harvestLat.push(res.data.results[0].geometry.location.lat)
            harvestLong.push(res.data.results[0].geometry.location.lng)
          }
        })
        .catch(err => console.log(err))
      
      )) 

      axios.get(baseGeoCodeURL + appkey + "&address=" + packingLocation) 
      .then(res => {
        setPackingData(res.data.results[0].geometry.location)
        setPackingReady(true)
      })
      .catch(err => console.log(err))
      
      setPackData({
        pack: locationData.pack_number ,
        batch: locationData.honey_batch_code,
        cropYear: locationData.crop_year,
        floral: locationData.floral_sources,
        harvestLocations: harvestLocations,
        hiveLocations: hiveLocations,
        packingLocation: `${locationData.packing_city}, ${locationData.packing_state}`,
        color: locationData.color,
        flavorClass: locationData.flavor_class,
        viscosity: locationData.viscosicty,
        crystalization: locationData.tendency_to_crystalize
      })
    } else {

      // single
      const hiveLocation = `${locationData.hive_counties}, ${locationData.hive_states}`
      const harvestLocation = `${locationData.harvest_counties}, ${locationData.harvest_states}`
      const packingLocation = `${locationData.packing_city}, ${locationData.packing_state}`
      let baseGeoCodeURL = "https://maps.googleapis.com/maps/api/geocode/json?key="
      let appkey = "AIzaSyDB9blrZbn1diWSfUegk7bw5SpitJ-C4vM"

      axios.get(baseGeoCodeURL + appkey + "&address=" + packingLocation) 
      .then(res => {
        setPackingData(res.data.results[0].geometry.location)
        setPackingReady(true)
      })
      .catch(err => console.log(err))

      axios.get(baseGeoCodeURL + appkey + "&address=" + hiveLocation) 
      .then(res => {
        setHiveData(res.data.results[0].geometry.location)
        setHiveReady(true)
      })
      .catch(err => console.log(err))

      axios.get(baseGeoCodeURL + appkey + "&address=" + harvestLocation) 
      .then(res => {
        setHarvestData(res.data.results[0].geometry.location)
        setHarvestReady(true)
      })
      .catch(err => console.log(err))

      setPackData({
        pack: locationData.pack_number ,
        batch: locationData.honey_batch_code,
        cropYear: locationData.crop_year,
        floral: locationData.floral_sources,
        harvestLocation: harvestLocation,
        hiveLocation: hiveLocation,
        packingLocation: `${locationData.packing_city}, ${locationData.packing_state}`,
        color: locationData.color,
        flavorClass: locationData.flavor_class,
        viscosity: locationData.viscosicty,
        crystalization: locationData.tendency_to_crystalize
      })
      

    }
  }
  


  const prevPage = (e) => {
    if (showPage === 0) {
    } else {
      setShowPage(showPage - 1)
    }
  }

  const nextPage = (e) => {
    if(showPage === 4) {

    } else {
      setShowPage(showPage + 1)
    }
  }

  const goToPage = (page) => {
    setShowPage(page)
  }


  const formPage = (e) => {
    setShowLoader(false)
    setHarvestReady(false)
    setHiveReady(false)
    setPackingReady(false)
    setDataReady(false)
    setMultipleLoc(false)
    setShowPage(0)
    window.scrollTo(0, 0);
  }

  return (
    <div className="App" id="map-app">
    <Helmet>
        <meta charSet="utf-8" />
        <title>Honey Journey || Busy Bee Honey</title>
    </Helmet>
    {(showPage === 0) &&

      <div id="bb-form-page">
        
            <div id="form-truck-wrap">
                <img id="form-truck" src={Truck} alt="Illustration of apiaries on delivery truck with moon behind and bee in foreground" />
            </div>
            <h1>FOLLOW YOUR HONEY'S JOURNEY</h1>
       
            <form onSubmit={handleSubmit} id="pack-form">
                <p>See where the bees made your honey, the flowers they foraged and the journey from extraction to packaging.
                </p>
                <label htmlFor="honey-number">Find your Real Honey Code on your label or to-go packet.</label>
                <input type="text" id="honey-number" placeholder="Enter Code Here" />
            </form>  
            <span className="form-hint">Need help finding your code? <button onClick={openModal}>Click here</button></span>
           {!showLoader &&
            <input type="submit" form="pack-form" value="submit" />
           }
           
           <div className="loader-wrap" role="status">
            {showLoader &&
              <img src={Loader} alt="loading" />
            }
          </div>
            <div className="form-error" role="status">
              {formError && <h2>Sorry, that code can't be found.</h2>}
            </div>
    
            {
              // handles advancement for single map
              (dataReady && harvestReady && hiveReady && packingReady) && nextPage()}
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              contentLabel="Code Finder Modal"
              style={customStyles}
          >
              <button id="modal-closer" onClick={closeModal}>X</button>
              <div className="bb-modal-inside">
                <h2>BUSY BEE BOTTLES</h2>
                <p>Peel the back label to find your traceability code.</p>
                <div className="modal-img">
                  <img src={Bottle} alt="busy bee honey bottle with label open and circle drawn around code bottom of label near cap" />
                </div>
                <h2>CREAMED HONEY JAR</h2>
                <p>Look for the traceability code on the back of your jar.</p>
                <div className="modal-img">
                  <img src={Jar} alt="back of Busy Bee honey jar with code circled bottom right of label " />
                </div>
                <h2>TO-GO PACKET</h2>
                <p>Find your traceability code on the front of each to-go packet.</p>
                <div className="modal-img">
                  <img src={Togo} alt="Front of to-go packet with code circled towards bottom center of packet" />
                </div>
            </div>
          </Modal>
        </div>
    }
    
    {(showPage !== 0)  &&
      <>
        <div className="map-wrapper">
          {!multipleLoc && 
            <Map 
            hiveData ={hiveData}
            harvestData = {harvestData}
            packingData = {packingData}
            showPage = {showPage} 
            /> 
          }
          {multipleLoc && 
            <MapMultiple
              goToPage = {goToPage}
              hiveData ={hiveData}
              harvestData = {harvestData}
              packingData = {packingData}
              showPage = {showPage}
            />
          }
        </div>
        <div className="info-wrapper">
          <HoneyNav
          
            showPage = {showPage}
            prevPage = {prevPage}
            nextPage = {nextPage}
            formPage = {formPage}
          />
          <HoneySubNav 
            showPage = {showPage}   
            goToPage = {goToPage}>
          </HoneySubNav>
      
          {showPage === 1 &&
            <StepOne 
            multipleLoc = {multipleLoc}
            packData = {packData}
            />
          }
      
          {showPage === 2 &&
            <StepTwo 
            multipleLoc = {multipleLoc}
            packData = {packData}
            />
          }
      
          {showPage === 3 &&
            <StepThree 
            packData = {packData}
            />
          }
      
          {showPage === 4 &&
            <StepFour 
            packData = {packData}
            />
          }
        </div>
       
      </>
    }

    </div>
  );
}

export default App;
